export const FLAG_GETTING_DELIVERIES = 'FLAG_GETTING_DELIVERIES';
export const GET_DELIVERIES = 'GET_DELIVERIES';
export const CLEAR_DELIVERIES = 'CLEAR_DELIVERIES';
export const FLAG_DELIVERY_ACTIVITY = 'FLAG_DELIVERY_ACTIVITY';
export const GET_DELIVERY = 'GET_DELIVERY';
export const CLEAR_DELIVERY = 'CLEAR_DELIVERY';
export const OPEN_MODAL = 'OPEN_MODAL';
